import { Component, Renderer2, RendererFactory2, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef, StatusPanelDef, GridOptions, IMultiFilterParams, GridPreDestroyedEvent, GridReadyEvent } from 'ag-grid-community';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Crop } from 'src/app/models/crop';
import { GridPreference } from 'src/app/models/gridPreference';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { ReportModalHeaderComponent } from 'src/app/shared/reportModalHeader';
import { StaticFields } from 'src/app/shared/staticFields';

@Component({
  selector: 'app-commonreportmodal',
  templateUrl: './commonreportmodal.component.html',
  styleUrl: './commonreportmodal.component.scss'
})
export class CommonreportmodalComponent {
  selectedCrop : any;
  program: string;
  disableCrop : boolean = true;
  assessmentMembersList: any[]= [];
  type: string ="";
  assessmentMembers: any[] = [];
  searchType: string = "Get All Assessments";
  searchBy: string = "GE ID";
  selectType: string = "Show all Assessments";
  showSelected : boolean = false
  selectedMembers: any;
  rowData : any[] =[];
  tab1RowData: any[] = [];
  tab2RowData: any[] = [];
  tab3RowData: any[] = [];
  tab4RowData: any[] = [];
  idList: string[] = [];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: { buttons: ["clear"] },
    minWidth : 50, 
    resizable: true,
  };
  public columnDefs: ColDef[] = [];
  public tab1ColDef: ColDef[] = [];
  public tab2ColDef: ColDef[] = [];
  public tab3ColDef: ColDef[] = [];
  public tab4ColDef: ColDef[] = [];
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
      { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
     
    ],
  };
  gridOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    singleClickEdit: true,
    tooltipShowDelay: 100,
    defaultColDef: {
      width: 165,
      minWidth: 20,
      filterParams: {
        filters: [
          {
            filter: "agSetColumnFilter",
            filterParams: { buttons: ["clear"] }
          },
        ]
      } as IMultiFilterParams
    },
    sideBar: { toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] },
    getRowStyle: (params: any) => {
      if ((this.url === "GetLineGraph" && params.data && params.data["gen"] === 0) || (this.url === "GetDHRequestDetails" && params.data && params.data["pgm_Matching"] === "No")) {
        return { backgroundColor: 'lightgray'};
      } else {
        return null;
      }
    }
    // onGridPreDestroyed: this.onGridPreDestroyed
  }
  gridApi: any;
  tab1GridApi: any;
  tab2GridApi: any;
  tab3GridApi: any;
  tab4GridApi: any;
  selectedType: string;
  userGridPreference: GridPreference = new GridPreference();
  navigatedExternal: boolean = false;
  url: string = "";
  report: boolean = false;
  renderer: Renderer2;
  selGeIds: string;
  programs: string[] = [];
  years: string[] = StaticFields.years;
  stages: string[] = [];
  selYears: any;
  selPrograms: any;
  selStages: any;
  showSearch: boolean = true;
  usageData: any;
  activeItem: MenuItem = {};
  tabItems: MenuItem[] = [{label: 'Source Data'},{label: 'Family Usage Summary'},{label: 'Parent Usage Summary'},{label: 'Grandparent Usage Summary'}];

  constructor(private apiService : ApiService, private commonService : CommonService,public customMessageService: CustomMessageService, 
    private confirmationService : ConfirmationService, private router : ActivatedRoute, private config : DynamicDialogConfig,private readonly rendererFactory: RendererFactory2,
    private viewContainerRef: ViewContainerRef) {
    this.selectedType = 'Show all Assessments';
    this.renderer = rendererFactory.createRenderer(null,null);
    if (this.config.data) {
      this.idListText = this.config.data?.ids ? this.config.data?.ids : "";
      this.selectedCrop = this.config.data.report ? this.config.data.crop : this.config.data.crop ? this.crops.find(ele => ele.Name == this.config.data.crop) : this.crops[0];
      this.selGeIds = this.config.data.selGeIds;
      this.program = this.config.data?.program;
      this.selYears = config.data.usageYears;
      this.selPrograms = config.data.usagePrograms;
      this.url = this.config.data.url;
      this.report = this.config.data.report;
      this.type = this.config.data?.type ? this.config.data?.type : "";
      this.searchBy = this.type == 'poprequest' ? 'DH Request ID' : this.searchBy;
      this.activeItem = this.tabItems[0];
      if (this.report)
        this.retrieveData();
      else if (this.type === 'nursery') {
        this.getPrograms();
      } else if (this.type === 'usage') {
        this.getPrograms();
        this.getStages();
      }
    }
  }
  get idListText(): string {
    return this.idList.join("\r\n");
  }

  set idListText(value) {
    this.idList = value.split(/\r?\n/);
    if (this.idList.length < 2)
      this.idList = value.split(",");
    this.idList = this.idList.filter((v, i, a) => a.indexOf(v) === i);
    this.idList = this.idList.map(s => s.trim()).filter(s => s);
    if ((this.searchBy === 'DH Request ID' || this.searchBy === 'GE ID') && this.idList.filter(id => isNaN(Number(id))).length > 0)
      this.customMessageService.showMessage({severity: "warn",summary: "Inavlid value", detail: "Only numeric values are allowed." });
  }

  get crops(): Crop [] {
    return StaticFields?.crops && StaticFields?.crops?.length > 0 ? StaticFields?.crops?.filter(ele => ele.isActive) : [];
  }

  get enableSearch(): boolean {
    if (this.type === 'usage')
      return this.idListText.length > 0 && this.selPrograms && this.selPrograms.length > 0 && this.selYears && this.selYears.length > 0;
    else if (this.type === 'nursery')
      return this.idListText.length > 0 && this.program ? true: false;
    return this.idListText.length > 0;
  }

  ngOnInit(): void {
    if (StaticFields.appUserId)
      this.setScreenData();  
    else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId) {
          this.setScreenData();
          clearInterval(interval);
        }
      }, 2000);
    }
  }

  onCropChange() {
    if (!this.report && this.type === 'nursery') {
      this.getPrograms();
    }
    if (!this.report && this.type === 'usage') {
      this.getPrograms();
      this.getStages();
    }
  }

  getPrograms() {
    //this.apiService.getRADData(`Programs?$filter=CropId eq ${this.selectedCrop.Id} and Status/Name eq 'Active'&$select=Id,Code,Description`, false).subscribe((result : any) => {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${this.selectedCrop.Name}'and IsActive&$select=Id,Code,Description${selectCountry}`).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      this.programs = result.value.map((r: any) => r.code);
    });
  }

  getStages() {
    const allStageValues = StaticFields.masterData?.filter(p => p.type == 'Stage' && p.crop == this.selectedCrop.Name && p.isActive); 
    this.stages = allStageValues.map((s: any) => s.stage);
  }

  setScreenData() {
    setTimeout(() => {
      const componentRef = this.viewContainerRef.createComponent(ReportModalHeaderComponent);
      componentRef.instance.incomingData = Object.create(this);
      let titleSpan = document.getElementsByClassName('p-dialog-header-icons')[0];
      this.renderer.insertBefore(titleSpan, componentRef.location.nativeElement,titleSpan.childNodes[0])
    },300);
  }

  resetPreferences() {
    this.confirmationService.confirm({
      header: 'Reset',
      icon: 'pi pi-exclamation-triangle',
      message: `Do you want to reset the search criteria ?`,      
      accept: () => {
        this.selectedCrop = StaticFields.precodePreference?.crop ? this.crops.find(ele => ele.Name === StaticFields.precodePreference.crop) : this.crops[0];
        this.idList = [];
        this.rowData.splice(0);
        StaticFields.lineGraphPageData = null;
      }
    });
    
  }
  
  onGridPreDestroyed($event: GridPreDestroyedEvent<any,any>) {
    if (!$event.context.showGrouped &&  StaticFields.codingPageData)
      StaticFields.lineGraphPageData.colState = $event.api.getColumnState();
  }

  retrieveData() {
    if ((this.searchBy === 'DH Request ID' || this.searchBy === 'GE ID') && this.idList.filter(id => isNaN(Number(id))).length > 0) {
      this.customMessageService.showMessage({severity: "warn",summary: "Inavlid value", detail: "Only numeric values are allowed." });
      return;
    }
    let postData : any = {};
    postData['crop'] = this.selectedCrop.Name;
    if (this.type === 'nursery') {
      postData['exptIds'] = this.report ? this.idList.map(id => Number(id)).filter(id => id) : [];
      postData['program'] = this.program;
      postData['geIds'] = this.report ? (this.selGeIds ? this.selGeIds.split(",").map(id => Number(id)).filter(id => id) : null) : this.searchBy !== 'CVN' ? this.idList.map(id => Number(id)).filter(id => id) : null;
      postData['geNames'] = this.searchBy === 'CVN' ? this.idList : null;
    } else if (this.type === 'usage') {
      postData['years'] = this.selYears;
      postData['programs'] = this.selPrograms;
      postData['stages'] = this.selStages;
      postData['geIds'] = this.idList.map(id => Number(id)).filter(id => id);
    } else {
      if (this.type === 'pstage')
        postData['hideEZRegion'] = StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0 ? true : false;
      if (this.searchBy == "DH Request ID") {
        postData["requestIds"] = this.idList.map(id => Number(id)).filter(id => id);
        if (postData['requestIds'].length === 0) {
          this.customMessageService.showMessage({severity: "warn",summary: "No Data", detail: "No data found for your search." });
          return;
        }
        postData['geIds'] = this.report && this.selGeIds ? this.selGeIds.split(",").map(id => Number(id)).filter(id => id) : null;
      } else if(this.searchBy == "DH Request Name") {
        postData["requestNames"] = this.idList;
      } else if (this.searchBy == "CVN") {
        postData['geIds'] = [];
        postData['cvn'] = this.idList;
      } else {
        postData['geIds'] = this.idList.map(id => Number(id)).filter(id => id);
        if (postData['geIds'].length === 0) {
          this.customMessageService.showMessage({severity: "warn",summary: "Inavlid Format", detail: "Only numeric values are allowed." });
          return;
        }
        postData['cvn'] = [];
      }
    }
    this.rowData.splice(0);
    this.columnDefs.splice(0);
    this.usageData = null;
    this.activeItem = this.tabItems[0];
    this.apiService.postData(this.url, postData, false,true).subscribe({
      next: (response: any) => {
        if (this.type === 'usage' && response && response.source.length > 0) {
          this.usageData = response;
          this.loadUsageTab(null);
          this.tabItems.forEach(item => {
            let tabName: string;
            if (item.label === 'Source Data') {
              tabName = 'source';
              this.tab1RowData = this.usageData[tabName];
              this.setColDef(tabName, this.tab1ColDef);
            } else if (item.label === 'Family Usage Summary') {
              tabName = 'family';
              this.tab2RowData = this.usageData[tabName];
              this.setColDef(tabName, this.tab2ColDef);
            } else if (item.label === 'Parent Usage Summary') {
              tabName = 'parent';
              this.tab3RowData = this.usageData[tabName];
              this.setColDef(tabName, this.tab3ColDef);
            } else {
              tabName = 'grandparent';
              this.tab4RowData = this.usageData[tabName];
              this.setColDef(tabName, this.tab4ColDef);
            }
            item.disabled = this.usageData[tabName].length === 0;
            if (item.disabled)
              item.tooltipOptions = { tooltipLabel: `No ${item.label} found` };
          });
          this.showSearch = false;
        } else if(response && response.length > 0) {
          setTimeout(() => {
            const ids : any = this.idList;
            if(this.searchBy == "CVN") {
              response.sort(function (a : any, b : any) {
                return ids.indexOf(a.cvn) - ids.indexOf(b.cvn);
              });
            } else {
              let searchIds : any = [];
              ids.forEach((ele : any) => searchIds.push(Number(ele)));              
              response.sort(function (a : any, b : any) {
                return searchIds.indexOf(Number(a.geid)) - searchIds.indexOf(Number(b.geid));
              });
            }  
            Object.keys(response[0]).forEach(k => {
              let header = '';
              if (k.toLowerCase() === 'ge_id')
                header = "GEID";
              else if (k.toLowerCase().startsWith('geid_node_') || k.toLowerCase().includes('_comments') || k.toLowerCase().includes('_metadata'))
                header = this.capitalizeHeader(k, true);
              else if (k.toLowerCase() === 'sapr' || k.toLowerCase() === 'dhqual' || k.toLowerCase() === 'ez')
                header = k.toUpperCase();
              else
                header = this.capitalizeHeader(k, false);
              this.columnDefs.push({ field: k, headerName: header, headerTooltip : k})
            });                                  
            this.rowData = [...response];
          },500)
          this.showSearch = false;
        } else {
          this.customMessageService.showMessage({severity: "warn",summary: "No Data Found", detail: "There was no data found for selected combination" })
        }       
      }
    });
  }

  setColDef(tabName: string, colDefs: any[]) {
    if (this.usageData[tabName].length > 0) {
      colDefs.splice(0);
      Object.keys(this.usageData[tabName][0]).forEach(k => {
        let header = '';
        if (k.toLowerCase() === 'ge_id' || k.toLowerCase() === 'geid')
          header = "GEID";
        else if (k.toLowerCase().startsWith('geid_node_') || k.toLowerCase().includes('_comments') || k.toLowerCase().includes('_metadata'))
          header = this.capitalizeHeader(k, true);
        else if (k.toLowerCase() === 'sapr' || k.toLowerCase() === 'dhqual' || k.toLowerCase() === 'ez')
          header = k.toUpperCase();
        else
          header = this.capitalizeHeader(k, false);
        colDefs.push({ field: k, headerName: header, headerTooltip : k})
      });
    }
  }

  loadUsageTab(args: any) {
    if (!this.usageData)
      return;
    let tabName = !args || args.label === 'Source Data' ? 'source' : args.label === 'Family Usage Summary' ? 'family' : args.label === 'Parent Usage Summary' ? 'parent' : 'grandparent';
    if (tabName && this.usageData[tabName].length > 0) {
      this.rowData.splice(0);
      setTimeout(() => {
        const data = JSON.parse(JSON.stringify(this.usageData[tabName]));
        this.setColDef(tabName, this.columnDefs);
        this.rowData = data;
      }, 10);
    } else {
      this.customMessageService.showMessage({severity: "warn",summary: "No Data Found", detail: "There was no data found for " + args.label });
    }
  }

  capitalizeHeader(header: string, splitNCapitalize: boolean) {
    if (splitNCapitalize) {
      const parts = header.split('_');
      parts[0] = parts[0].toUpperCase();
      return parts.join('_');
    }
    return header.charAt(0).toUpperCase() + header.slice(1);
  }

  export() {
    if (this.type === 'usage')
      this.exportMultipleSheets();
    else
      this.commonService.downloadExcelFile(this.gridApi);
  }

  exportMultipleSheets() {
    const excelSheets: any = [];
    let i = 1;
    this.tabItems.forEach(item => {
      const gridApi = i === 1 ? this.tab1GridApi : i === 2 ? this.tab2GridApi : i === 3 ? this.tab3GridApi : this.tab4GridApi;
      if (gridApi)
        excelSheets.push(gridApi.getSheetDataForExcel({ sheetName: item.label }));
      i++;
    });

    let excelBlob: any = this.gridApi.getMultipleSheetsAsExcel({ data: excelSheets });
    this.apiService.downloadExcel(excelBlob);  
  }

  // saveGridPreferences() {
  //   const cols = JSON.stringify(this.gridApi.getColumnState());
  //   if (!this.userGridPreference?.appUserId) {
  //     this.userGridPreference.appUserId = StaticFields.appUserId;
  //     this.userGridPreference.gridName= this.selectedCrop.Name + ":" + "lineGraphPage";
  //   }
  //   StaticFields.lineGraphPageData.colState = this.userGridPreference.preference = cols;
  //   this.apiService.putData('SubmitUserGridPreference', this.userGridPreference).subscribe();   
  // }

  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
    // let savedCols = null;
    
    // if (this.userGridPreference?.preference) {
    //   savedCols = JSON.parse(this.userGridPreference.preference);
    // }

    // this.gridApi.applyColumnState({ state: savedCols, applyOrder: true });
  }
  onTab1GridReady(args: any) {
    this.tab1GridApi = args.api;
  }
  onTab2GridReady(args: any) {
    this.tab2GridApi = args.api;
  }
  onTab3GridReady(args: any) {
    this.tab3GridApi = args.api;
  }
  onTab4GridReady(args: any) {
    this.tab4GridApi = args.api;
  }
  onNGSearch(word: string, item: string): boolean {
    return item.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }
}
